import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { resizeIframe } from './utils/iframe';

window.apps = {
    resizeIframe,
};
